import * as React from 'react';
import styled from "styled-components"

// import { DictioneryPanel } from '../../../Data/DictioneryPanel';
import BoxDesign from '../reports/BoxDesign';
import Paper from '@mui/material/Paper';
import img from '../images/Room1.png';
import log from '../images/Room1.png';
import hmap from '../images/hotelmap.png';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';

const PrintStyle = styled.div`-direction-print-right: 0;
  --direction-print-left: 1;
  --ad-prime-1: var(--n-grey-1);
  --main-color: var(--n-grey-2);
  font-family: var(--font-en) !important;
  * {
    font-family: var(--font-en) !important;
  }
  /* direction: rtl; */
  &.agency {
    --main-color: #6C648B;
    --ad-prime-1: #6C648B20;
  }
  &.broker {
    --main-color: #FEA202;
    --ad-prime-1: #FEA20220;
  }
  &.rtl {
    direction: ltr;
    font-family: var(--font-fa) !important;
    * {
      font-family: var(--font-fa) !important;
    }
    --direction-print-right: 0;
    --direction-print-left: 1;
  }
  @page {
  size: portrait;
}
.print-footer {
  position: fixed;
  bottom: 0;
}
  .print-header {
    margin: 0 0 2rem;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.7rem;
    align-items: center;
    font-size: 1.2rem;
    .header-row {
     // width: calc(100% - 2rem);
      padding: 1rem;
      font-weight: 700;
    }
    .expand {
      flex-grow: 1;
    }
    .image {
      width: 80px;
      height: 80px;
      border-radius: 200px;
      border: 1px solid var(--n-grey-2);
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
    }
    .dates {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      .date {
        display: flex;
        justify-content: space-between;
        gap: 0.5rem;
      }
    }
  }
`

export default function HotelVoucher_Print(props) {

  return (
    //  <div className='printing' ref={componentRef}>
    <div style={{ border: 'solid' }}>
      <PrintStyle >
      <div className='print-header' style={{alignContent:'center', display:'inherit' }}>
          <div className='header-row' >

            <img src={log} alt="farazandishan"  />
          </div>
          <div style={{marginLeft:'20px',fontSize:'22px' ,fontWeight:'bold', alignContent: 'left' ,float:'left' ,marginTop:'-80px'}} >
         <div     >
            Hotel Voucher
          </div>
        </div> 

        </div>


           
        <BoxDesign className={"top-box"}>
          <div className='filters' style={{ display: 'inherit', float: 'right', marginRight: '10px' }}>
            <img src={img} alt="/" style={{ width: '200px', height: '200px' }} />
          </div>

          <div className='rowleft' style={{ border: 'solid', marginLeft: '10px', marginRight: '10px' }} >
            <div className='filter-title' style={{ display: 'flex' }}>

              <TableContainer component={Table}  >
                <Table size='small' >

                  <TableBody>

                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px', width: '150px' }} >Hotel Name:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}> Luxin Hotel</TableCell>
                    </TableRow>
                    <TableRow
                      key={2}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px' }}>City: </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>Tbilisi</TableCell>
                    </TableRow>
                    <TableRow
                      key={3}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px' }}>website:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>luxinhotel.com</TableCell>
                    </TableRow>
                    <TableRow
                      key={4}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px' }}>Email:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>info@luxinhotel.com</TableCell>
                    </TableRow>
                    <TableRow
                      key={5}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px' }}>Tel:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>+995511225552</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>


              <TableContainer component={Table} style={{ marginLeft: '50px' }}  >
                <Table size='small'  >

                  <TableBody>

                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }} >Check In:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}> {props.Checkindate.slice(0, 10)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={2}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }}>Check Out: </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>{props.Checkoutdate.slice(0, 10)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={3}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }}>Room:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>Standard</TableCell>
                    </TableRow>
                    <TableRow
                      key={4}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }}>Room Service:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>Bed & Breakfast</TableCell>
                    </TableRow>
                    <TableRow
                      key={5}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }}></TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

          </div>
        </BoxDesign>
        <br></br>
        <div style={{ border: 'solid', fontSize: '22px', fontWeight: 'bold', height: '350px', marginLeft: '10px', marginRight: '10px' }}>
          <BoxDesign className={"filters"} style={{ marginTop: '10px' }}>
            passneger Detail
            <TableContainer component={Paper} style={{ width: 'auto' }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead style={{ backgroundColor: '#F2F2F2' }}>
                  <TableRow >
                    <TableCell style={{ fontSize: '14px', fontWeight: 'bold' }}>First Name</TableCell>
                    <TableCell align="left" style={{ fontSize: '14px', fontWeight: 'bold' }} >Last Name</TableCell>
                    <TableCell align="left" style={{ fontSize: '14px', fontWeight: 'bold' }} >Passport No</TableCell>
                    <TableCell align="left" style={{ fontSize: '14px', fontWeight: 'bold' }}>Telephone (mobile number) </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.datas.map((row) => (
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0, fontSize: '12px', fontWeight: 'bold' } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.Pass_FName}
                      </TableCell>
                      <TableCell align="left">{row.Pass_LName}</TableCell>
                      <TableCell align="left">{row.Pass_No}</TableCell>
                      <TableCell align="left">{row.Pass_PhonNo}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </BoxDesign>

        </div>
        <div className='top-box' style={{ border: 'solid', marginTop: '20px', marginLeft: '10px', marginRight: '10px' }}>

          <div className='title' style={{marginLeft:'20px', textAlign: 'left', fontSize: '12', fontWeight: 'bold' }} >
            Location

          </div>
          <BoxDesign className={"top-box"} style={{ marginTop: '20px' }}>



            <img src={hmap} width="900" height="650" style={{ border: 0 }}   referrerpolicy="no-referrer-when-downgrade"></img>

          </BoxDesign>

          <BoxDesign className={"top-box"}>

            <div className='top-box' style={{marginLeft:'20px', marginTop: '10px', textAlign: 'left', fontSize: '22px', fontWeight: 'bold' }} >

              Adress:Avlabari SQ. konstantin Eristavi  5 Luxin Hotel, Tbilisi

              {/* </BoxDesign>
      <BoxDesign className={"top-box"}> */}
              <div style={{ marginLeft:'10px',marginTop: '10px', textAlign: 'left' }}>

                Location: Avlabari , Tbilisi, Georgia
              </div>
              <br></br>
            </div>
          </BoxDesign>



        </div>
      </PrintStyle>
      <br></br>
    </div>


    // </div>


  )
}